// public/js/modules/filters/filter-manager.js
export class FilterManager {
    constructor() {
      this.filters = new Map();
      this.state = {};
      this.onChangeCallbacks = [];
    }
  
    registerFilter(key, filterModule) {
      this.filters.set(key, filterModule);
      this.state[key] = filterModule.getDefaultState?.() || {};
    }
  
    renderAll(container) {
      container.innerHTML = Array.from(this.filters.entries())
        .map(([key, f]) => f.renderUI?.(this.state[key] || {}, this) || '')
        .join('');
    }
  
    updateFilter(key, newState) {
      if (this.state[key]) {
        this.state[key] = { ...this.state[key], ...newState };
      }
      this.onChangeCallbacks.forEach(cb => cb(key));  // key mitgeben
    }
  
    applyFilters(assets) {
      let filtered = [...assets];
      for (const [key, filter] of this.filters) {
        if (typeof filter.apply === 'function') {
          filtered = filter.apply(filtered, this.state[key] || {});
        }
      }
      return filtered;
    }
  
    onChange(callback) {
      this.onChangeCallbacks.push(callback);
    }
  
    getState() {
      return { ...this.state };
    }

    clearOnChange() {
      this.onChangeCallbacks = [];
    }
    
  }
  
  // Global instance
  export const mapFilterManager = new FilterManager();